import React__default from 'react';
import { Text } from '@amzn/storm-ui';
import { u as useIntl } from '../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-BLE3wELi-CV9fXVbx.js';

const NoSearchResultsText = () => {
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React__default.createElement(Text, {
    size: "base",
    color: "secondary",
    withMargin: true
  }, formatMessage({
    id: 'search-no-results'
  }));
};

export { NoSearchResultsText as N };
//# sourceMappingURL=NoSearchResultsText-s1E5MS4q.js.map
